import { matchPath } from 'react-router-dom';
import { ROUTES } from '@constants';

export enum PageName {
  APPOINTMENT_TIME_PREFERENCE = 'Appointment Time Preference',
  BOOKING_CONFIRMATION = 'Booking Confirmation',
  COMPLETE_BOOKING = 'Complete Booking',
  COMPLETE_YOUR_PROFILE = 'Complete Your Profile',
  CONFIRM_NUMBER = 'Confirm Number',
  CREATE_PASSWORD = 'Create Password',
  EMAIL = 'Email',
  GET_STARTED = 'Get Started',
  NUMBER = 'Number',
  REFERRAL_LANDING_PAGE = 'Referral Landing Page',
  RESCHEDULE = 'Reschedule',
  SCHEDULE_YOUR_VISIT = 'Schedule Your Visit',
  ID_VERIFICATION = 'ID Verification',
}

type PageMatcher = {
  path: string;
  end?: boolean;
  page: PageName;
};

const pageMatches: PageMatcher[] = [
  { path: '/services/*', end: false, page: PageName.GET_STARTED },
  { path: '/reschedule/*', end: false, page: PageName.RESCHEDULE },
  {
    path: '/schedule/appointment-time-preference/:id',
    page: PageName.APPOINTMENT_TIME_PREFERENCE,
  },
  { path: '/schedule/*', end: false, page: PageName.SCHEDULE_YOUR_VISIT },

  { path: ROUTES.email.path, page: PageName.EMAIL },
  { path: ROUTES.phone.path, page: PageName.NUMBER },
  { path: ROUTES.confirmYourNumber.path, page: PageName.CONFIRM_NUMBER },
  { path: ROUTES.completeProfile.path, page: PageName.COMPLETE_YOUR_PROFILE },
  { path: ROUTES.createPassword.path, page: PageName.CREATE_PASSWORD },
  { path: ROUTES.completeBooking.path, page: PageName.COMPLETE_BOOKING },
  {
    path: ROUTES.bookingConfirmation.path,
    page: PageName.BOOKING_CONFIRMATION,
  },
  { path: ROUTES.idVerification.path, page: PageName.ID_VERIFICATION },
  { path: ROUTES.referral.path, page: PageName.REFERRAL_LANDING_PAGE },
];

export default function getPageNameFromPath(
  pathname: string,
): PageName | undefined {
  const path = pathname.split('?')[0];

  for (const match of pageMatches) {
    if (
      matchPath(
        {
          path: match.path,
          end: match.end ?? true,
        },
        path,
      )
    ) {
      return match.page;
    }
  }
}
